import client from "../../graphql/client";
import { loader } from "graphql.macro";

const removeOrganisationLabelMutation = loader("../../graphql/mutations/removeCompanyLabel.graphql");

export default function removeOrganisationLabelAction(id) {
    return () => {
        return client.mutate({
            mutation: removeOrganisationLabelMutation,
            variables: { id }
        });
    };
}
